import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { UtilService } from './util.service';
declare var $: any;
@Injectable()
export class MasterService {

  constructor(
    private apiService:ApiService,
    private util:UtilService
  ) { }

  async  InitDropDown(system: string, action: string, data: any, id: string) {
    var res: any =  await this.apiService.post(system, action, data);
    $('#' + id).find('option').remove().end();
    console.log(res);
    if (res.isSuccess) {
      var obj: any = res.responseData;
      var select = <HTMLSelectElement>document.getElementById(id);
      for (var i = 0; i < obj.length; i++) {
        var opt = document.createElement('option');
        opt.value = obj[i].ddl_value;
        opt.innerHTML = obj[i].ddl_text;
        select.appendChild(opt);
      }
    } else {
       this.util.ErrorDialog(obj.errorMessage);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/utility/master.service.ts